import { Col, DatePicker, Form, Input, InputNumber, Radio, Row } from "antd";
import dayjs from "dayjs";
import React from "react";
import { weightLossOptions } from "../../../../IpEMR/Options/dietAdviceOptions";
import useReceptionistMobilePickerProps from "../../../../Receptionist/receptionistMobilePickerProps";

const DietDetails = () => {
  const mobilePickerProps = useReceptionistMobilePickerProps();

  return (
    <>
      <Row gutter={[12, 0]}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Observed Date" name="observed_date">
            <DatePicker
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
              inputReadOnly
              style={{ width: "100%" }}
              {...mobilePickerProps}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Present Weight" name="present_weight">
            <InputNumber addonAfter="kgs" style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item label="Current Diet Order" name="current_diet_order">
            <Input autoComplete="off" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Wt. Loss/Gain" name="weight_loss_gain">
        <Radio.Group options={weightLossOptions} />
      </Form.Item>

      <Row gutter={[12, 0]}>
        <Col xs={12} sm={8} md={6}>
          <Form.Item label="RBS/FBS" name="rbs_fbs">
            <Input autoComplete="off" />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item label="BUN/Creat" name="bun_creat">
            <Input autoComplete="off" />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item label="Triglyceride" name="triglyceride">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item label="Na+" name="sodium">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item label="K+" name="potassium">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item label="Hb" name="hemoglobin">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item label="Albumin" name="albumin">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={16} md={12}>
          <Form.Item label="Any Other" name="any_other">
            <Input autoComplete="off" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default DietDetails;
